import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InfoCommerce, TaxValidation, TypePerson, TypePersonOption } from './model/tax-validation';
import { SesionService } from 'src/app/core/service/sesion.service';
import { Subscription } from 'rxjs';
import { TaxValidationService } from './service/tax-validation.service';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';

@Component({
  selector: 'app-tax-validation',
  templateUrl: './tax-validation.component.html',
  styleUrls: ['./tax-validation.component.scss'],
})
export class TaxValidationComponent implements OnInit {
  taxForm: FormGroup;
  submitted: boolean;
  categorizedAfip: boolean = false;
  loading: boolean;
  rucNotEnrolled: boolean;
  rucNotRegistered: boolean;
  sessionData: TaxValidation | null;
  potentialCustomerData: PotentialCustomer | null;
  state: string = '';
  warningCuitText: string = '';
  isDuplicated: boolean = false;
  infoCommerce: InfoCommerce | undefined;
  @Output()
  onComplete = new EventEmitter<number>();
  rucSubscription: Subscription = new Subscription();
  @Output()
  onBack = new EventEmitter();
  validateOcrCount: number = 0;
  warningBirthdayText: string = 'Você é menor de idade';
  ocrError: boolean = false;
  maxDate = new Date();
  stateRegisterIsRequired: boolean = true;
  personOption: any = TypePersonOption;
  typePerson: string = '';
  @ViewChild('errorDiv') errorDiv: ElementRef | undefined;
  // private bucketSubscription: Subscription | undefined;

  constructor(
    private readonly fb: FormBuilder,
    private readonly sesion: SesionService,
    private readonly taxService: TaxValidationService,
    // private serviceUploadFile: FileUploadService,
    // private readonly bucketService: FilePresignUrlUploadService,
  ) {
    this.submitted = false;
    this.loading = false;
    this.rucNotEnrolled = false;
    this.rucNotRegistered = false;
    this.sessionData = this.sesion.getItem('tax_validation');
    this.potentialCustomerData = this.sesion.getItem('potential_customer');
    this.taxForm = this.fb.group({
      socialReason: [this.sessionData ? this.sessionData.socialReason : ''],
      cpf: [this.sessionData ? this.sessionData.cpf : ''],
      name: [this.sessionData ? this.sessionData.name : ''],
      surname: [this.sessionData ? this.sessionData.surname : ''],
      cnpj: [this.sessionData ? this.sessionData.cnpj : ''],
      stateRegisterNumber: [
        this.sessionData ? this.sessionData.stateRegisterNumber : undefined,
        [Validators.pattern(/^[0-9]*$/)],
      ],
      typePerson: [this.sessionData ? this.sessionData.typePerson : '', Validators.required],
      dateOfBirth: [this.sessionData?.dateOfBirth ? new Date(this.sessionData.dateOfBirth) : undefined],
      stateRegisterISENTO: [this.sessionData?.isento ? this.sessionData?.isento : undefined],
    });
    if (this.sessionData?.typePerson) {
      this.selectPersonType(this.sessionData?.typePerson);
    }
  }

  ngOnInit(): void {
    this.formValueChanges();
  }

  changeIsento(event: any) {
    console.log('event', event.checked);
    if (event.checked) {
      this.changeControlsValidations('stateRegisterNumber', false);
      this.stateRegisterIsRequired = false;
    } else {
      this.stateRegisterIsRequired = true;
      this.changeControlsValidations('stateRegisterNumber', true);
    }
  }

  formValueChanges() {
    this.taxForm.controls['cnpj'].valueChanges.subscribe(() => {
      this.changeCNPJ();
    });
    this.taxForm.controls['cpf'].valueChanges.subscribe(() => {
      this.changeCPF();
    });
    this.taxForm.controls['typePerson'].valueChanges.subscribe(() => {
      this.selectPersonType(this.taxForm.controls['typePerson'].value);
    });

    this.taxForm.controls['name'].valueChanges.subscribe((value) => {
      this.taxForm.controls['name'].setValue(value.toUpperCase(), {
        emitEvent: false,
      });
    });

    this.taxForm.controls['surname'].valueChanges.subscribe((value) => {
      this.taxForm.controls['surname'].setValue(value.toUpperCase(), {
        emitEvent: false,
      });
    });

    this.taxForm.controls['socialReason'].valueChanges.subscribe((value) => {
      this.taxForm.controls['socialReason'].setValue(value.toUpperCase(), {
        emitEvent: false,
      });
    });
  }

  back() {
    this.onBack.emit();
  }

  // agregarGuion(value: string) {
  //   if (value.length > 5) {
  //     const guionesAntiguos = value.match(/-/g) || [];
  //     const cantidadGuiones = guionesAntiguos.length;
  //     if (cantidadGuiones > 0) {
  //       value = value.replace(/-/g, '');
  //     }
  //     let legnth = value.length - 1;
  //     value = value.slice(0, legnth) + '-' + value.slice(legnth);
  //     this.taxForm.controls['ruc'].setValue(value, {
  //       emitEvent: false,
  //     });
  //   }
  // }

  changeCNPJ() {
    this.loading = false;
    let ruc = this.taxForm.controls['cnpj'].value;
    let validValue = ruc.replace(/[^0-9\-]/g, ' ');
    if (ruc !== validValue) {
      this.taxForm.controls['cnpj'].setValue(validValue);
      this.taxForm.controls['cnpj'].setValue(validValue.trim());
    }
    //this.agregarGuion(ruc);
  }

  async changeCPF() {
    this.loading = false;
    let ci = this.taxForm.controls['cpf'].value;
    if (ci.length == 11) {
      // this.validateOcrCount = 0;
      // this.ocrValidation('ciInput');
    }
  }

  // ocrValidation(from: string) {
  //   let ci: string = '';
  //   if (this.taxForm.controls['ci'].value) ci = this.taxForm.controls['ci'].value;
  //   let file: FileSave[] = this.taxForm.controls['fileFrontCi'].value;
  //   if (file && file[0].file) {
  //     let src = file[0].src.replace(/^data:image\/[a-z]+;base64,/, '');
  //     this.fileService.validateOcr(src, ci).subscribe(
  //       (data) => {
  //         if (data.message == 202) this.ocrValidationFail(from);
  //         else this.ocrValidationCorrect(data);
  //       },
  //       (error) => {
  //         this.ocrValidationFail(from);
  //       },
  //     );
  //   }
  // }

  selectPersonType(event: any) {
    this.typePerson = event;
    if (this.typePerson == TypePerson.FISICA) {
      this.personIsFisica();
    } else if (this.typePerson == TypePerson.JURIDICA) {
      this.personIsJuridica();
    }
  }

  personIsFisica() {
    const patternCI: RegExp = /^[a-zA-Z0-9]+$/;
    this.changeControlsValidations('cpf', true, 11, 11, patternCI);
    // this.changeControlsValidations('fileFrontCi', true);
    // this.changeControlsValidations('fileBackCi', true);
    this.changeControlsValidations('name', true);
    this.changeControlsValidations('surname', true);
    this.changeControlsValidations('cnpj', false);
    this.changeControlsValidations('stateRegisterNumber', false);
    this.changeControlsValidations('socialReason', false);
    this.changeControlsValidations('dateOfBirth', true);
    this.validateOcrCount = 0;
    this.ocrError = false;
  }

  personIsJuridica() {
    if (this.taxForm.controls['stateRegisterISENTO'].value) {
      this.changeControlsValidations('stateRegisterNumber', false);
      this.stateRegisterIsRequired = false;
    } else {
      this.changeControlsValidations('stateRegisterNumber', true);
      this.stateRegisterIsRequired = true;
    }
    this.changeControlsValidations('cpf', false);
    this.changeControlsValidations('cnpj', true, 14, 14);

    // this.changeControlsValidations('fileFrontCi', false);
    // this.changeControlsValidations('fileBackCi', false);
    this.changeControlsValidations('name', true);
    this.changeControlsValidations('surname', true);
    this.changeControlsValidations('socialReason', true);
    this.changeControlsValidations('dateOfBirth', false);
  }

  // ocrValidationCorrect(data: any) {
  //   this.ocrError = false;
  // }

  // ocrValidationFail(from: string) {
  //   if (this.validateOcrCount >= 1) {
  //     this.ocrError = false;
  //   } else {
  //     console.log('ocr error', this.taxForm.controls['fileFrontCi'].value);
  //     this.bucketSubscription = this.bucketService
  //       .deleteFileBucket(this.taxForm.controls['fileFrontCi'].value[0]?.name)
  //       .subscribe(() => console.log('El documento se eliminó correctamente'));
  //     this.taxForm.controls['fileFrontCi'].reset();
  //     this.ocrError = true;
  //     if (from == 'fileInput') {
  //       this.validateOcrCount++;
  //       //this.taxForm.controls["nameComplete"].setValue("");
  //     }
  //   }
  // }

  changeControlsValidations(control: string, required: boolean, max?: number, min?: number, pattern?: RegExp) {
    if (required) {
      this.taxForm.controls[control].addValidators(Validators.required);
      if (max) {
        this.taxForm.controls[control].addValidators(Validators.maxLength(max));
      }
      if (min) {
        this.taxForm.controls[control].addValidators(Validators.minLength(min));
      }
      if (pattern) {
        this.taxForm.controls[control].addValidators(Validators.pattern(pattern));
      }
    } else {
      this.taxForm.controls[control].clearValidators();
      this.taxForm.controls[control].setErrors(null);
      this.taxForm.controls[control].setValue('');
    }
    this.taxForm.controls[control].updateValueAndValidity();
  }

  onSubmit() {
    if (!this.loading) {
      this.submitted = true;
      if (this.taxForm.valid) {
        this.saveAndValidated();
      }
    }
  }

  saveAndValidated() {
    let numIdem;
    let tipoIdem = '';
    if (this.taxForm.controls['typePerson'].value == 'F') {
      numIdem = this.taxForm.controls['cpf'].value;
      tipoIdem = 'CPF';
    } else {
      numIdem = this.taxForm.controls['cnpj'].value;
      tipoIdem = 'CNPJ';
    }
    this.taxService.getDuplicated(numIdem).subscribe((data) => {
      if (data) {
        this.isDuplicated = true;
        this.warningCuitText =
          'Registramos una solicitud abierta para este Nro de ' +
          tipoIdem +
          '. Por favor esperar al tratamiento de la misma. Cualquier duda contactar al centro de servicios al cliente. Gracias!';
        this.errorDiv?.nativeElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        this.saveInfoTaxValidation();
      }
    });
  }

  saveInfoTaxValidation() {
    this.loading = true;
    let data: TaxValidation = this.createTaxDto();
    if (
      (this.Is18YearsOld(this.taxForm.controls['dateOfBirth'].value) &&
        (!this.taxForm.controls['cpf'].value || Number(this.taxForm.controls['cpf'].value) > 0)) ||
      (this.taxForm.controls['cnpj'].value > 0 && !this.taxForm.controls['cpf'].value)
    ) {
      this.sesion.setItem('tax_validation', data);
      this.formComplete();
    }
  }

  createTaxDto(): TaxValidation {
    let data: TaxValidation = {
      cpf: this.taxForm.controls['cpf'].value,
      cnpj: this.taxForm.controls['cnpj'].value,
      name: this.taxForm.controls['name'].value,
      surname: this.taxForm.controls['surname'].value,
      typePerson: this.taxForm.controls['typePerson'].value,
      socialReason: this.taxForm.controls['socialReason'].value,
      dateOfBirth: this.taxForm.controls['dateOfBirth'].value,
      stateRegisterNumber: this.taxForm.controls['stateRegisterNumber'].value,
      isento: this.taxForm.controls['stateRegisterISENTO'].value,
    };
    return data;
  }

  formComplete() {
    this.onComplete.emit(4);
  }

  Is18YearsOld(dateBirth: Date): boolean {
    const todayDate = new Date();
    const dateBirthday = new Date(dateBirth);

    let age = todayDate.getFullYear() - dateBirthday.getFullYear();
    const monthDif = todayDate.getMonth() - dateBirthday.getMonth();

    // Ajustar la edad si el cumpleaños no ha ocurrido aún este año
    if (monthDif < 0 || (monthDif === 0 && todayDate.getDate() < dateBirthday.getDate())) {
      age--;
    }

    return age >= 18;
  }
}
